import { Injectable } from '@angular/core';

/**
 * InputLimit service.
 * Provides utility methods to limit input fields to a maximum length and optionally restrict to digits only.
 * Useful for form validation and input sanitization.
 */
@Injectable({
  providedIn: 'root' // makes it globally available
})

export class InputLimit {
  formData: Record<string, string> = {}; // instead of any

  /**
   * Limits an input field to digits or text with a max length.
   *
   * @param event - Input event from HTML input element
   * @param maxLength - Maximum allowed characters/digits
   * @param digitsOnly - If true, removes all non-digit characters
   */
  limitInput(event: Event, maxLength: number, digitsOnly: boolean = false): void {
    const inputElement: HTMLInputElement = event.target as HTMLInputElement;
    let value: string = inputElement.value;

    // If only digits allowed
    if (digitsOnly) {
      value = value.replace(/\D/g, '0');
    }

    // Trim to maximum length
    if (value.length > maxLength) {
      value = value.slice(0, maxLength);
    }

    // Update input value
    inputElement.value = value;

    // Update the bound ngModel property if it exists
    const controlName: string | null = inputElement.getAttribute('name');
    if (controlName && controlName in this.formData) {
      this.formData[controlName] = value;
    }
  }
}
